import { useStore } from "../../../context";
import React from "react";
import { navigate } from "@reach/router";
import TagManager from "react-gtm-module";
import "../../../styles/theme.css";
import logoanai from "../../../images/logos/logoanai.png";

export default () => {
  const { dispatch } = useStore();

  const handleClickOpenEstAnai = () => {
    TagManager.dataLayer({
      dataLayer: { event: "pageview", path: "/matricula/anai" }
    });
    dispatch({ type: "SET_LOGIN", payload: "A" });
    navigate("/matricula/list");
  };

  const handleClickOpenEstNuevo = () => {
    TagManager.dataLayer({
      dataLayer: { event: "pageview", path: "/matricula/nuevo" }
    });
    dispatch({ type: "SET_LOGIN", payload: "N" });
    navigate("/matricula/list");
  };

  return (
    <div className="login-bg">
      <div className="login-card" style={{ maxWidth: 420, textAlign: "center" }}>
        <img src={logoanai} alt="ANAI" style={{ width: 90, marginBottom: 10 }} />
        <h2 style={{ color: "#0d1b3e", marginBottom: 6, fontSize: "1.5rem" }}>Matrículas</h2>
        <p style={{ color: "#888", fontSize: "0.92rem", marginBottom: 24 }}>
          Seleccione el tipo de estudiante para continuar con el proceso de matrícula.
        </p>

        <button
          className="btn-modern"
          style={{ width: "100%", marginBottom: 14 }}
          onClick={handleClickOpenEstNuevo}
        >
          🎓 Nuevo Estudiante
        </button>

        {/* <button
          className="btn-modern btn-modern-secondary"
          style={{ width: "100%" }}
          onClick={handleClickOpenEstAnai}
        >
          🏫 Estudiante ANAI
        </button> */}

        <div className="modern-copyright">
          © {new Date().getFullYear()} Academia Naval Almirante Illingworth
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};
